/**
 * @description 키보드 배열이 연속해서 세개 이상 입력되었는지 체크하는 함수
 * @returns boolean, (true: 연속한 문자열이 있음, false: 연속한 문자열이 없음)
 */

const validateConsecutiveKeyboardPattern = (str: string) => {
  const consecutiveForwardWords = [
    '1234567890-=',
    '~!@#$%^&*()_+',
    'qwertyuiop[]',
    'QWERTYUIOP{}',
    'asdfghjkl;',
    'ASDFGHJKL:',
    'zxcvbnm,./',
    'ZXCVBNM<>?',
  ];

  const consecutiveWords = [
    ...consecutiveForwardWords.map((w) => w.split('').reverse().join('')),
    ...consecutiveForwardWords,
  ];

  for (let i = 0; i < str.length - 2; i++) {
    const slicedValue = str.slice(i, i + 3);

    if (consecutiveWords.some((word) => word.includes(slicedValue))) {
      return true;
    }
  }

  return false;
};

export default validateConsecutiveKeyboardPattern;
